var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgTagV2 = function SvgTagV2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M47.89 26.28v-9.25c.06-.44 0-.93-.15-1.24-.03-.06-.06-.12-.1-.16-.01-.02-.03-.03-.05-.04a.333.333 0 0 0-.21-.09h-8.3c-1.21 0-2.63-.21-3.82 0-.44.08-.63.35-.95.66L20.99 29.48l-4.64 4.64c-.38.38-.38 1.63 0 2.02l12.31 12.31c.19.19.32.19.52 0l11.6-11.6 6.09-6.09c.47-.47.91-.77 1.01-1.47.14-.97.02-2.04.02-3.01Zm-3.99-2.42c-.69.9-1.92 1.25-2.98.84-1.03-.4-1.66-1.41-1.68-2.5.02-1.24.84-2.36 2.08-2.62 1.1-.23 2.24.31 2.79 1.29.52.93.44 2.15-.21 3Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTagV2);
export default ForwardRef;